/**
 * Registro del service worker — tarea 7.13
 *
 * SE REGISTRA TAMBIÉN EN DESARROLLO, y no es lo habitual. La razón es que la
 * única forma de comprobar que la aplicación abre sin cobertura es tener el
 * service worker activo donde se prueba, y aquí eso importa más de lo normal:
 * es el hueco que quedó declarado en la tarea 7.4 y lo que sostiene la cola de
 * incidencias sin conexión.
 *
 * Registrarlo en desarrollo sólo es seguro porque la estrategia es RED PRIMERO
 * (ver `public/sw.js`): con cobertura, todo se pide al servidor y la recarga en
 * caliente de Vite sigue funcionando. Con «caché primero» esto sería
 * insoportable —módulos viejos servidos a traición— y habría que restringirlo a
 * producción.
 *
 * SI EL NAVEGADOR NO LO ADMITE, NO PASA NADA. La aplicación funciona igual, sin
 * modo sin conexión. Por eso todo esto va envuelto en comprobaciones y no lanza.
 */

export function registrarServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  // `secureContext` cubre https y localhost. Sin él, el registro falla con una
  // excepción en cuanto alguien abre la aplicación por IP en la red de la
  // oficina, y esa excepción no tiene nada que ver con lo que estuviera
  // haciendo.
  if (!window.isSecureContext) return;

  // Se espera a `load`: registrarlo antes compite por el ancho de banda con lo
  // que hace falta para pintar la primera pantalla.
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Un registro fallido no puede romper la aplicación. Se pierde el modo
      // sin conexión y ya está.
    });
  });
}
